<template>
  <div class="stock-momentum-list-view">
    <StockMomentumList />
  </div>
</template>

<script>
import StockMomentumList from '@/components/screening/StockMomentumList.vue'

export default {
  name: 'StockMomentumListView',
  components: {
    StockMomentumList
  }
}
</script>

<style scoped>
.stock-momentum-list-view {
  flex: 1;
}
</style>
